import React from "react";
import AgentLayout from "../../../agentComponents/AgentLayout";
import CampaignSync from "./CampaignSync";

const CampaignSyncView = () => (
  <AgentLayout title="Campaign Sync" subtitle="Push and reconcile campaign data.">
    <CampaignSync />
  </AgentLayout>
);

export default CampaignSyncView;
